export const authMessages = {
  "auth/too-many-requests":
    "TOO MANY ATTEMPTS TRY LATER: Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later.",
  "auth/wrong-password": "Incorrect email or password.",
  "auth/user-not-found": "Incorrect email or password.",
  "password-no-match": "Password and Confirm Password are not matching",
  "auth/email-already-in-use": "Email already exists, try to log in.",
};
